import {
  GetAdminsBlogs,
  GetBlog,
  GetMasterTechnologies,
} from "./blogApis/blogApi";

import { GetAllArticle, postArticle } from "./ArticleApi/Article";
import { UpdateNewsletter } from "./newsletterApi/newsletter";

export const ApiKey = {
  Login: "connect/token",
  GetTechnology: "/GetTechnologyCategories",
  GetTechnologyByCategoryId: "GetTechnologiesByCategoryId",

  loginKey: "auth/admin/login",
  updateUserDetail: "User/UpdateUserProfile",
  getUserDetail: "User/GetUserDetailById",
  getUserManagementList: "/user/GetAllusers",
  getUserManagementListbyId: "/user/GetUsersbyId",
  testingUrl: "/Blog/GetAllComment",
  // testingUrl: "/Blog/admin/GetAllComment",

  GetMasterTechnologies: "/Master/GetTechnologiesByCategoryId",
  AddMasterTechnologies: "/Master/InsertTechnologies",
  UpdateMasterTechnologies: "/Master/UpdateTechnologies",
  ChangemasterTechnologiesStatus: "/Master/ChangeTechnologyStatus",
  GetMasterTechnologiesCategory: "/Master/GetTechnologyCategories",
  AddMasterTechnologiesCategory: "/Master/InsertTechnologyCategory",
  UpdateMasterTechnologiesCategory: "/Master/UpdateTechnologyCategory",
  ChangeMasterTechnologiesCategoryStatus:
    "/Master/ChangeTechnologyCategoryStatus",
  GetAdminBlogs: "/Blog/GetAdminsBlogs",
  // GetAdminBlogs: "/Blog/admin/GetAdminsBlogs",
  GetMasterAllTechnologies: "Master/GetAllMasterTechnologies",
  postBlog: "/Blog/PostBlog",
  GetBlog: "/Blog/singleBlog",
  DeleteBlog: "/Blog/DeleteBlogById",
  UpdateBlog: "/Blog/UpdateBlog",

  getblogsByStatus: "Blog/GetBlogsByStatus",
  changeBlogVisibility: "Blog/ChangeBlogIsActive",
  changeBlogStatus: "Blog/ChangeBlogStatus",

  DashboardCount: "Master/GetDashboardCount",
  createAdmin: "/User/CreateAdmin",
  getUsersPaginated: "/User/GetAllUsers",
  deleteUser: "/User/DeactivateUser/",
  restoreUser: "/User/ReactivateUsers",
  changeVisibility: "/Blog/changeBlogVisibility",

  blogUrl: "Blog/GetTechnologies",
  GetSingleArticle: "Article/GetSingleArticle",
  postArticle: "Article/PostArticle",
  PaginatedArticle: "Article/PaginatedArticles",
  editArticle: "Article/UpdateArticle",
  deleteArticle: "Article/DeleteArticle",
  setVisibilityArticle: "Article/SetVisibilityArticle",
  getNewsletter: "Newsletter/GetNewsletter",
  insertNewsletter: "Newsletter/InsertNewsletter",
  deleteNewsletter: "Newsletter/DeleteNewsletter",
  toggleNewsletterStatus: "Newsletter/ToggleNewsletterStatus",
  getSingleNewsletterAdmin: "Newsletter/GetSingleNewsletter",
  updateNewsletter: "Newsletter/UpdateNewsletter",

  GetRegisteredEmail: "Newsletter/newsletterSubscribers",
  changeStatus: "Article/ChangeStatus",
  getAllReqContent: "UserContent/GetAllContentsOfBlogOrArticle",
  actionOnContentUpdateReq: "UserContent/ActionByAdminsOnUpdateReq",
  newsLetterToRegisteredEmail: "Newsletter/NewsLetterToRegisteredEmail",
  logout: "auth/logout",
  verifyOTP: "/auth/VerifyOtp",
  updatePassword: "/auth/UpdatePassword",
  changePasswordByOldPassword: "/auth/ChangePasswordByOldPassword",
  getOtpEmail: "/auth/admin/GetOtpOnEmail",
  getClientDetectionEmails: "/api/v1/email/getClientDetectionEmails", // Added endpoint for client detection emails
};
